import React from "react"
import styled from "styled-components"
import { ICONS } from "@/constants"
import Icon from "@/components/common/Icon/Icon"
import { getCssSizeValue } from "@/utils/utils"
import { BREAKPOINTS } from "@/styles/themeSettings"

const StyledPaginationPagerWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	width: 100%;
	margin-top: ${getCssSizeValue(49, BREAKPOINTS.DESKTOP)};
	//padding: 50px 0;
`

const StyledThreeDots = styled.div`
	color: ${({ theme }) => theme.colors.richBlue};
	font-family: ${({ theme }) => theme.fontFamily.bornaFont};
	font-size: 18px;
	font-weight: ${({ theme }) => theme.fontWeight.medium};
	line-height: normal;
	margin-right: 8px;
	//margin-left: -8px;
	//margin-right: 8px;
`

const ButtonIconWrapper = styled.div`
	//height: 14px;
	//height: 14px;
	//width: 24px;
	width: 14px;
	cursor: pointer;
	pointer-events: ${({ disabled }) => (disabled ? "none" : "initial")};

	&.left {
		margin-right: 16px;

		svg {
			transform: rotate(180deg);
		}
	}

	svg {
		path {
			fill: ${({ theme }) => theme.colors.richBlack} !important;
			display: ${({ disabled }) => (disabled ? "none" : "block")};
		}
	}
`

const StyledSingleNumberWrapper = styled.div`
	width: 32px;
	height: 32px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin-right: 8px;
	cursor: pointer;
	padding-right: 1px;

	p {
		font-weight: ${({ theme }) => theme.fontWeight.medium};
		color: ${({ theme }) => theme.colors.richBlack};
	}

	&.active {
		background-color: ${({ theme }) => theme.colors.chilliRed};

		p {
			color: ${({ theme }) => theme.colors.white};
		}
	}
`
const PageNumbers = ({ currentPage, numberOfPages, handleClick }) => {
	const pageNumbers = []

	if (numberOfPages <= 5) {
		for (let i = 1; i <= numberOfPages; i++) {
			pageNumbers.push(i)
		}
	} else {
		if (currentPage < 4) {
			pageNumbers.push(1, 2, 3, 4, "...", numberOfPages)
		} else if (currentPage >= 4 && currentPage <= numberOfPages - 3) {
			pageNumbers.push(1, "...", currentPage - 1, currentPage, currentPage + 1, "...", numberOfPages)
		} else {
			pageNumbers.push(1, "...", numberOfPages - 3, numberOfPages - 2, numberOfPages - 1, numberOfPages)
		}
	}

	return pageNumbers.map((page, index) => {
		if (page === "...") {
			return <StyledThreeDots key={index}>...</StyledThreeDots>
		} else {
			return (
				<StyledSingleNumberWrapper key={index} className={currentPage === page ? "active" : ""} onClick={() => handleClick(page)}>
					<p className="typo-strawford typo-strawford-86">{page}</p>
				</StyledSingleNumberWrapper>
			)
		}
	})
}
const PaginationBar = ({ currentPage, numberOfPages, handleClick, className = "", ...props }) => {
	return (
		<StyledPaginationPagerWrapper className={`${className} pagination-bar`} {...props}>
			<ButtonIconWrapper className="left" disabled={currentPage === 1} onClick={() => handleClick(currentPage - 1)}>
				<Icon name={ICONS.CHEVRON} />
			</ButtonIconWrapper>
			<PageNumbers currentPage={currentPage} numberOfPages={numberOfPages} handleClick={handleClick} />
			<ButtonIconWrapper onClick={() => handleClick(currentPage + 1)} disabled={currentPage === numberOfPages}>
				<Icon name={ICONS.CHEVRON} />
			</ButtonIconWrapper>
		</StyledPaginationPagerWrapper>
	)
}

export default PaginationBar
